import * as types from "../constants/userDetailConstants";
import { LOGOUT } from "../constants/authConstants";

const initialState = {
  userDetail: null,
  rawData: null,
  transformedData: null,
  loading: false,
  error: null,
  accessDenied: false,
  accessReason: null,
  accessMessage: null,
};

const userDetailReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT:
      return {
        ...state,
        userDetail: null,
        rawData: null,
        transformedData: null,
        loading: false,
        error: null,
      };

    case types.GET_USER_DETAIL_LOADING:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_USER_DETAIL_SUCCESS:
      return {
        ...state,
        userDetail: payload.transformedData,
        rawData: payload.rawData,
        transformedData: payload.transformedData,
        loading: false,
        error: null,
        accessDenied: payload.accessDenied || false,
        accessReason: payload.reason || null,
        accessMessage: payload.message || null,
      };

    case types.GET_USER_DETAIL_FAIL:
      return {
        ...state,
        userDetail: null,
        rawData: null,
        transformedData: null,
        loading: false,
        error: payload,
      };

    case types.CLEAR_USER_DETAIL:
      return {
        ...state,
        userDetail: null,
        rawData: null,
        transformedData: null,
        loading: false,
        error: null,
        accessDenied: false,
        accessReason: null,
        accessMessage: null,
      };

    default:
      return state;
  }
};

export default userDetailReducer;

